import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { AudioProvider } from "./contexts/AudioContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Toaster } from "./components/ui/sonner";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PublicMediatheque from "./pages/PublicMediatheque";
import PendingApproval from "./pages/PendingApproval";

// Dashboard Layout and Pages
import { DashboardLayout } from "./components/layout/DashboardLayout";
import Overview from "./pages/dashboard/Overview";
import Events from "./pages/dashboard/Events";
import Contributions from "./pages/dashboard/Contributions";
import Members from "./pages/dashboard/Members";
import Finances from "./pages/dashboard/Finances";
import Mediatheque from "./pages/dashboard/Mediatheque";
import Learning from "./pages/dashboard/Learning";
import Documents from "./pages/dashboard/Documents";
import SocialLinks from "./pages/dashboard/SocialLinks";
import Notifications from "./pages/dashboard/Notifications";
import AdminNotifications from "./pages/dashboard/AdminNotifications";
import Settings from "./pages/dashboard/Settings";
import AuditTrail from "./pages/dashboard/AuditTrail";
import Spiritualite from "./pages/dashboard/Spiritualite";
import Communaute from "./pages/dashboard/Communaute";
import LecturesCollectives from "./pages/dashboard/LecturesCollectives";

// Hubs thématiques (regroupent les pages ci-dessus en onglets — navigation mobile)
import SpiritualiteHub from "./pages/dashboard/SpiritualiteHub";
import CommunauteHub from "./pages/dashboard/CommunauteHub";
import FinancesHub from "./pages/dashboard/FinancesHub";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
      <AudioProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/public-mediatheque" element={<PublicMediatheque />} />
            <Route path="/pending-approval" element={<PendingApproval />} />

            {/* Protected Dashboard Routes */}
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Overview />} />
              <Route path="events" element={<Events />} />
              <Route path="contributions" element={<Contributions />} />
              {/* "Engagements" fusionné dans "Événements" : on redirige les anciens liens */}
              <Route path="engagements" element={<Navigate to="/dashboard/events" replace />} />
              {/* Hubs thématiques (onglets) — destinations de la barre mobile */}
              <Route path="spiritualite" element={<SpiritualiteHub />} />
              <Route path="communaute" element={<CommunauteHub />} />
              <Route path="finances" element={<FinancesHub />} />
              {/* Ancien hub "Plus" : le menu secondaire est désormais le tiroir
                  de la barre d'onglets. On redirige les anciens liens. */}
              <Route path="plus" element={<Navigate to="/dashboard/settings" replace />} />

              {/* Routes granulaires conservées (sidebar bureau + liens directs) */}
              <Route path="spiritualite-culte" element={<Spiritualite />} />
              <Route path="lectures" element={<LecturesCollectives />} />
              <Route path="forum" element={<Communaute />} />
              <Route path="members" element={<Members />} />
              <Route path="comptabilite" element={<Finances />} />
              <Route path="mediatheque" element={<Mediatheque />} />
              <Route path="learning" element={<Learning />} />
              <Route path="documents" element={<Documents />} />
              <Route path="social-links" element={<SocialLinks />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="admin-notifications" element={<AdminNotifications />} />
              <Route path="settings" element={<Settings />} />
              <Route path="audit" element={<AuditTrail />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AudioProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
